export const proxyCdnUrl = (url?: string | null): string | null => {
  if (!url) return null;

  return url.replace('cdn.shotix.art/', 'proxy-cdn.shotix.art/');
};
